const routerArr = [
  {
    path: 'shopList',
    component: (resolve) => require(["page/tradeAreaMangement/shop/index"], resolve),
    meta: { show: '1110', title: '店铺管理', source: '11b8' },
  },
  {
    path: 'shopList/shopAdd',
    component: (resolve) => require(["page/tradeAreaMangement/shop/addEdit"], resolve),
    meta: { show: '1110', title: '新增店铺', source: '11b8' },
  }
];

export default routerArr;



// WEBPACK FOOTER //
// ./src/container/pages/tradeAreaMangement/_res.js